<template>
  <div class="input-pop pop">
    <div class="pop-box">
      <div class="pop-main">
        <div class="pop-main-top">{{titleMsg}}</div>
        <div class="pop-main-test">
          <input type="text" :class="{'error': noInput}" :placeholder="$t('operation.floderName')" v-model="newFolderName" v-on:keyup="onChange" ref="input" v-focus>
        </div>
        <div class="pop-main-bottom">
          <button class="btn-black" @click="newFolder">{{$t('operation.confirm')}}</button>
          <button class="btn-grey" @click="closeInputPop">{{$t('list.cancel')}}</button>
        </div>
      </div>
      <i class="icon-close" @click="closeInputPop"></i>
    </div>
  </div>
</template>

<script>
import * as Config from 'common/script/config'
import HttpClient from 'common/script/http'
export default {
  name: 'inputPop',
  props: ['folder', 'title'],
  data () {
    return {
      newFolderName: '',
      noInput: false,
      titleMsg: this.$t('operation.msg')
    }
  },
  watch: {
    folder: function (newFolder, oldFolder) {
      this.getFileName()
    },
    newFolderName: function (newVal, oldVal) {
      this.newFolderName = Config.removeEmoji(this.newFolderName)
    }
  },
  created () {
    if (this.title) {
      this.titleMsg = this.title
    }
    this.getFileName()
  },
  methods: {
    onChange: function () {
      this.newFolderName = this.newFolderName.substring(0, 20)
    },
    getFileName: function () {
      // console.log('get name', this.folder)
      if (this.folder) {
        this.newFolderName = this.folder.name
      }
    },
    closeInputPop: function () {
      this.$emit('closeInputPop')
    },
    newFolder: function () {
      if (this.newFolderName === '' || this.newFolderName === null) {
        this.noInput = true
      } else {
        this.noInput = false
        if (this.folder) {
          HttpClient.postData(Config.APP_HOST + '/v1/file/dir/rename', {
            u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
            dirId: this.folder.id,
            name: this.newFolderName
          }, this).then((response) => {
            this.closeInputPop()
            if (response.code === Config.R_CODE.SUCCESS) {
              this.folder.name = this.newFolderName
              this.$emit('newFolder')
            }
          })
        } else {
          HttpClient.postData(Config.APP_HOST + '/v1/file/dir/create', {
            u_id: Config.cookieGet(Config.COOKIE_KEY.U_ID),
            name: this.newFolderName
          }, this).then((response) => {
            this.closeInputPop()
            if (response.code === Config.R_CODE.SUCCESS) {
              this.$emit('newFolder')
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.input-pop
  input
    width 184px
    height 30px
    background-color #f5f5f5
    border-radius 4px
    text-align center
    font-size 12px
    color #999
    outline none
    &.error
      border 1px solid #e36868
</style>



// WEBPACK FOOTER //
// src/components/Et/InputPop.vue